export default __webpack_public_path__ + "static/media/LO04.bef8cbb7.mp3";